/**
 * Normalize the `roles` field of an outgoing user payload:
 *   - wrap a single value into an array (backend expects array);
 *   - if the array contains `ROLE_DRIVER`, set `type` to `'DRIVER'` (legacy
 *     discriminator the backend still uses to route the entity).
 *
 * Mutates `values` in place. Same logic was duplicated in
 * `UserResource.eventHandlers.onBefore{Create,Update}RequestUrl`.
 */
export const normalizeRolesPayload = (values: Record<string, any>): void => {
    if (values['roles'] !== undefined && !Array.isArray(values['roles'])) {
        values['roles'] = [values['roles']]
    }
    if (Array.isArray(values['roles']) && values['roles'].includes('ROLE_DRIVER')) {
        values['type'] = 'DRIVER'
    }
}
